import { AppContent } from '@/theme1/components/app-content';
import { AppShell } from '@/theme1/components/app-shell';
import { AppSidebar } from '@/theme1/components/app-sidebar';
import { AppSidebarHeader } from '@/theme1/components/app-sidebar-header';

export default function AppSidebarLayout({
    children,
    breadcrumbs = [],
}) {
    return (
        <AppShell variant="sidebar">
            <AppSidebar />
            <AppContent variant="sidebar" className="overflow-x-hidden">
                <AppSidebarHeader breadcrumbs={breadcrumbs} />
                {children}
            </AppContent>
        </AppShell>
    );
}
